var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconW(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_15543",
    "data-name": "Path 15543",
    d: "M39.5,0A39.5,39.5,0,1,0,79,39.5,39.5,39.5,0,0,0,39.5,0ZM62.789,30.309c-2.246,5.075-9.116,21.151-13.7,31.629-.006,0-1.2,0-1.2,0L40.656,44.907c-2.865,5.619-6.04,11.461-8.754,17.02a12.5,12.5,0,0,1-1.315,0c-4.15-9.687-8.453-19.31-12.625-28.99-.966-2.366-4.354-6.172-6.672-6.15,0-.275-.013-.888-.016-1.259l14.29,0-.011,1.237c-1.678.078-4.578,1.148-3.826,3,2.014,4.349,9.145,21.2,11.073,25.473,1.345-2.632,5.1-9.649,6.647-12.615C38.234,40.13,34.228,30.842,33.027,28.5c-.906-1.525-3.179-1.712-4.93-1.738,0-.39.02-.691.013-1.227l12.562.039v1.141c-1.7.047-3.31.68-2.581,2.306,1.69,3.508,2.677,6,4.228,9.249.5-.95,3.035-6.16,4.245-8.909.731-1.828-.361-2.513-3.42-2.6.04-.3.014-.9.04-1.192l10.849.011,0,1.132A6.6,6.6,0,0,0,48.9,29.507L43.679,40.341c.573,1.433,5.6,12.592,6.124,13.829L60.6,29.24c-.769-2.018-3.22-2.469-4.178-2.491.006-.322.008-.812.01-1.222l11.275.032.016.057-.019,1.127A5.206,5.206,0,0,0,62.789,30.309Z",
    fill: "#c6c6c6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconW);
export default __webpack_public_path__ + "static/media/icon-w.796ed5c7bfee8cb86466ae18cee987e3.svg";
export { ForwardRef as ReactComponent };